/* eslint-disable react/prop-types */
import React, { ChangeEventHandler, FocusEventHandler, FormEventHandler, RefObject, useEffect, useRef } from 'react';
import { TextField } from '@material-ui/core';
import CardBody from 'components/Card/CardBody';
import { HeadingMBold } from 'components/Typography/Typography';
import { makeStyles } from '@material-ui/core';
import { FormikProps, FormikValues } from 'formik';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/MicroBundle/addNewMicroBundleStyle';
import { translate } from 'components/Translation';
import { formData } from '../constants';
interface IForm {
	formik: FormikProps<FormikValues>;
}

export interface IFromik {
	handleSubmit: FormEventHandler<HTMLFormElement>;
	values: Array<IValues>;
	handleChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
	handleBlur: FocusEventHandler<HTMLDivElement>;
}

interface IValues {
	name: string;
	email: string;
}

// @ts-ignore
const useStyles = makeStyles(styles);

// eslint-disable-next-line react/prop-types
export const Form = ({ formik }: any) => {
	const componentRef: RefObject<HTMLInputElement> = useRef(null);

	useEffect(() => {
		if (componentRef.current) {
			componentRef?.current.focus();
		}
	}, []);
	const classes = useStyles();
	return (
		<>
			<CardBody>
				<HeadingMBold>{translate('enter.contact-details')}</HeadingMBold>
				<form onSubmit={formik.handleSubmit} className={classes.formWrapper} data-testid="form">
					{formData.map((formElement, i) => {
						const name = formElement.name || '';
						const isReadOnly = formElement.readOnly 
						const variantProps = 
						isReadOnly
							? { variant: 'filled' as 'filled' }
							: { variant: 'outlined' as 'outlined' };

						return (
							<div key={formElement.id}>
									<TextField
										ref={i == 0 ? componentRef : null}
										tabIndex={0}
										className={classes.noBorder}
										fullWidth
										required={formElement.required}
										size="small"
										id={name}
										name={name}
										value={formik.values[name]}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										InputProps={{
											readOnly: isReadOnly,
										}}
										error={formik.touched[name] && formik.errors[name]}
										type={formElement.type}
										data-testid={formElement.name}
										helperText={formik.touched[name] && formik.errors[name]}
										placeholder={translate(formElement.label)}
										aria-label={translate(formElement.label)}
										aria-live='assertive'
										{...variantProps}
									/>
								</div>
						);
					})}
				</form>
			</CardBody>
		</>
	);
};
